import { Helmet } from "react-helmet-async";
import GetOfferForm from "@/components/tools/GetOfferForm";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/common/Logo";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";
import { cn } from "@/lib/utils";

const GetOfferPage = () => {
  const { topPadding } = useSafeAreaInsets();
  return (
    <>
      <Helmet>
        <title>Get a Cash Offer | GoDyspo</title>
        <meta
          name="description"
          content="Get a no-obligation cash offer for your property. Fill out our quick form and we'll get back to you with a fair offer."
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        {/* Header */}
        <header className={cn("border-b border-border bg-card/50 backdrop-blur-sm sticky top-0 z-50", topPadding)}>
          <div className="container mx-auto px-4 py-4 flex items-center gap-4">
            <Link
              to="/seller-net-sheet"
              className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
            >
              <ArrowLeft className="h-5 w-5" />
              <span className="hidden sm:inline">Back to Calculator</span>
            </Link>
            <div className="flex-1" />
            <Logo size="medium" context="public" />
          </div>
        </header>

        {/* Main Content */}
        <main className="container mx-auto px-4 py-8 max-w-2xl">
          <div className="text-center mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
              Get a <span className="text-godyspo-gold">Cash Offer</span>
            </h1>
            <p className="text-muted-foreground text-lg">
              Fill out the form below and we'll get back to you with a no-obligation offer.
            </p>
          </div>

          <GetOfferForm />
        </main>

        {/* Footer */}
        <footer className="border-t border-border py-6 mt-12">
          <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
            <p>© {new Date().getFullYear()} GoDyspo. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default GetOfferPage;
